import { Input } from '@atlas-design-system/react';
import { React } from 'react';

export function Filter({ column, table }) {
    const firstValue = table.getPreFilteredRowModel().flatRows[0]?.getValue(column.id)
    const columnFilterValue = column.getFilterValue()

    return typeof firstValue === 'number' ? (
        <div className="flex space-x-2">
            <Input
                type="number"
                //value={(columnFilterValue as [number, number])?.[0] ?? ''}
                value={columnFilterValue[0]}
                onChange={e =>
                    column.setFilterValue((old) => [
                        e.target.value,
                        old?.[1],
                    ])
                }
                placeholder={`Min`}
            />
            <Input
                type="number"
                //value={(columnFilterValue as [number, number])?.[1] ?? ''}
                value={columnFilterValue[1]}
                onChange={e =>
                    column.setFilterValue((old) => [
                        old?.[0],
                        e.target.value,
                    ])
                }
                placeholder={`Max`}
            />
        </div>
    ) : (
        <Input
            value={(columnFilterValue ?? '')}
            type="search" style={{ width: '100%', display: 'block' }}
            onChange={e => column.setFilterValue(e.target.value)}
            placeholder={`Search...`}
        />
    )
}